export default {
  'brand_id': null,
  'name': null,
  'logo': null,
  'line_limit': null,
  'content': null,
  'styles': null,
};
